import { Outlet, useLocation } from 'react-router-dom';
import { useState } from 'react';
import { ElectricianSidebar } from './ElectricianSidebar';
import { ElectricianHeader } from './ElectricianHeader';
import { PageHeading } from './PageHeading';
import { CartDrawer } from './CartDrawer';
import { PreviewBanner } from '../PreviewBanner';

export function ElectricianLayout() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  return (
    <div className="min-h-screen flex flex-col" style={{ background: 'var(--pro-bg)' }}>
      <PreviewBanner />
      <div className="flex min-h-0 flex-1">
      <div className="hidden lg:block sticky top-0 h-screen">
        <ElectricianSidebar />
      </div>

      {mobileOpen && (
        <>
          <div
            className="fixed inset-0 bg-black/30 z-40 lg:hidden pro-fade-in"
            onClick={() => setMobileOpen(false)}
            aria-hidden="true"
          />
          <div className="fixed top-0 left-0 h-full z-50 lg:hidden pro-slide-in-left">
            <ElectricianSidebar onNavigate={() => setMobileOpen(false)} />
          </div>
        </>
      )}

      <div className="flex-1 flex flex-col min-w-0">
        <ElectricianHeader onToggleSidebar={() => setMobileOpen((v) => !v)} />
        <main className="flex-1 overflow-y-auto">
          <div
            key={location.pathname}
            className="px-4 sm:px-6 pb-8 pro-fade-in"
          >
            {/* Titre + fil d'Ariane sur MOBILE — sur desktop ils restent dans
                l'en-tête, qui a la place de les porter. */}
            <PageHeading />
            <Outlet />
          </div>
        </main>
        <footer
          className="px-4 sm:px-6 py-6 flex flex-wrap items-center justify-between gap-3 text-[12px]"
          style={{ color: 'var(--pro-text-grey)', fontFamily: 'Figtree' }}
        >
          <div className="flex flex-wrap items-center gap-4">
            <span className="font-semibold">Copyright © 2025 TunelecPro</span>
            <span style={{ color: 'var(--pro-text-grey-light)' }}>politique de confidentialité</span>
            <span style={{ color: 'var(--pro-text-grey-light)' }}>Termes et conditions</span>
            <span style={{ color: 'var(--pro-text-grey-light)' }}>Contact</span>
          </div>
        </footer>
      </div>

      <CartDrawer />
      </div>
    </div>
  );
}
